var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_c('div',{staticClass:"container-fluid"},[_c('section',{staticClass:"app-main"},[_c('el-main',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1)],1)]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }